import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type DeleteEventParticipantPathRequestParams = paths['/events/{eventId}/participants']['delete']['parameters']['path'];
type DeleteEventParticipantQueryRequestParams =
  paths['/events/{eventId}/participants']['delete']['parameters']['query'];

export const deleteEventParticipants = async ({
  config,
  routeParams: { eventId },
}: ConfigRouteParamsRequest<DeleteEventParticipantQueryRequestParams, DeleteEventParticipantPathRequestParams>) =>
  nodeApiClient.delete<unknown, ApiClientResponse<unknown>>(nodeApiRoutes.events.participants.delete(eventId), config);
